import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, NavLink, Outlet } from 'react-router-dom';

import { useTypedProjectCostContext } from './useTypedProjectCostContext';

const tabLinkClass = ({ isActive }: { isActive: boolean }) =>
  `nav-link${isActive ? ' active' : ''}`;

const ProjectsCostSettingsLayout: React.FC = () => {
  const { openNewCompany, openNewRole, openNewDemandRate } = useTypedProjectCostContext<{
    openNewCompany: () => void;
    openNewRole: () => void;
    openNewDemandRate: () => void;
  }>();

  return (
    <>
      <nav aria-label="breadcrumb" className="cost-breadcrumb mb-2">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <Link to="/projects/costs">Visão geral</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Configurações
          </li>
        </ol>
      </nav>

      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
        <h4 className="mb-0">Configurações globais</h4>
        <div className="d-flex flex-wrap gap-2">
          <Button size="sm" onClick={openNewCompany}>Nova empresa</Button>
          <Button size="sm" onClick={openNewRole}>Nova função</Button>
          <Button size="sm" onClick={openNewDemandRate}>Nova taxa OS/AS</Button>
        </div>
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink to="/projects/costs/configuracoes/empresas" className={tabLinkClass}>Empresas</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/projects/costs/configuracoes/funcoes" className={tabLinkClass}>Funções</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/projects/costs/configuracoes/taxas-demanda" className={tabLinkClass}>Taxas OS/AS</NavLink>
        </li>
      </ul>

      <Outlet />
    </>
  );
};

export default ProjectsCostSettingsLayout;
